import { Button, Grid, Stack, Typography } from "@mui/material";

export default function ElementCard({ ops = {} }) {
  return (
    <Grid container spacing={2} justifyContent="flex-end">
      <Grid item xs={12}>
        <Stack>
          <Typography fontWeight="bold" variant={ops.titleVariant || "h6"}>
            {ops.title || "Sin título"}
          </Typography>
          {ops.details?.map((detail, index) => (
            <Typography variant="body2" key={index}>
              {detail}
            </Typography>
          ))}
        </Stack>
      </Grid>
      {ops.bottomActions &&
        ops.bottomActions.map((action, index) => (
          <Grid item key={index}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ color: "white" }}
              href={action.href}
              endIcon={action.endIcon}
            >
              {action.text}
            </Button>
          </Grid>
        ))}
    </Grid>
  );
}
